import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_WEB,
});

export default api;
